import React from 'react';

import {withI18n} from 'spa/Components/Context';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import './press-featured-new.less';

@withI18n
class PressFeaturedEN extends React.Component {
  render() {
    const {i18n} = this.context;

    return (
      <div className="press-featured__press-container container">
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              alt={i18n._x('Vogue Magazine logo', 'Press image alt text in the homepage')}
              className="press-featured__press-image--medium"
              height="30"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1495117100/home-en/optimised/Vogue.png"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1495117100/home-en/optimised/Vogue.png"
              width="101"
            />
          </p>
        </div>
        <div className="press-featured__press-element">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              alt={i18n._x('The Telegraph Newspaper logo', 'Press image alt text in the homepage')}
              className="press-featured__press-image"
              disableWebp
              height="32"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493200711/b2c-art/telegraph.svg"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493200711/b2c-art/telegraph.svg"
              width="89"
            />
          </p>
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered press-featured__press-element--mobile-top-bottom-border">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              alt={i18n._x('The Guardian Newspaper logo', 'Press image alt text in the homepage')}
              className="press-featured__press-image"
              disableWebp
              height="28"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493200739/b2c-art/guardian.svg"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493200739/b2c-art/guardian.svg"
              width="198"
            />
          </p>
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-top-bottom-border">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              alt={i18n._x('Timeout Magazine logo', 'Press image alt text in the homepage')}
              className="press-featured__press-image--medium"
              disableWebp
              height="31"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493200797/b2c-art/timeout-new.svg"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493200797/b2c-art/timeout-new.svg"
              width="111"
            />
          </p>
        </div>
        <div className="press-featured__press-element press-featured__press-element--mobile-bordered">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              alt={i18n._x('TechCrunch logo', 'Press image alt text in the homepage')}
              className="press-featured__press-image"
              disableWebp
              height="31"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/v1493200840/b2c-art/techcrunch-new.svg"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/q_15,e_blur:2000/v1493200840/b2c-art/techcrunch-new.svg"
              width="111"
            />
          </p>
        </div>
        <div className="press-featured__press-element">
          <p className="press-featured__press-img-wrapper">
            <ProgressiveImage
              alt={i18n._x('London Evening Standard logo', 'Press image alt text in the homepage')}
              className="press-featured__press-image--tall"
              height="44"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1495117099/home-en/optimised/eveningstandard-new.png"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1495117099/home-en/optimised/eveningstandard-new.png"
              width="57"
            />
          </p>
        </div>
      </div>
    );
  }
}

export default PressFeaturedEN;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/PressFeaturedEN.jsx